export const notFoundMessages = {
  en: {
    continueMessage: 'Continue here please.',
    header: "This page isn't available",
    message: 'The link may be broken, or the page may have been removed.',
    title: 'Page Not Found',
  },
};
